import { CompanyEditPage } from "@/features/company/pages/CompanyEdit";

const CompanyEdit = () => {
  return <CompanyEditPage />;
};

export default CompanyEdit;
